export default __webpack_public_path__ + "aba07a3057fed172956532f1b2312e77.wav";